export default __webpack_public_path__ + "static/media/short.7577c4f7.svg";